import { NewPaperWithPadding } from '@components/Misc';
import { Grid, TextInput, Typography } from '@ts/storybook';
import { IForm } from '@ts/ui-models';

interface IEventTypeTemplateTabProps extends IForm {}

const EventTypeTemplateTab = (props: IEventTypeTemplateTabProps) => {
  const { values, onCallbackChange } = props;
  const isViewMode = props.mode == 'view';

  return (
    <Grid container>
      <NewPaperWithPadding>
        <Grid container spacing={2} direction={'column'}>
          <Typography variant="h6" text="Details to copy in all new events of this type" className="mb-2" />
          <TextInput
            multiline
            isReadOnly={isViewMode}
            value={values.details}
            onChangeValue={onCallbackChange('details')}
            errorHint="If modified, the existing events will not be updated"
          />
        </Grid>
      </NewPaperWithPadding>
    </Grid>
  );
};

export default EventTypeTemplateTab;
